import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { DmFieldsService, EntityInstanceTransition } from '@module-instance/dynamic-module/common';
import { produce } from 'immer';
import { DocumentDetails } from '..';
import { IdValueType } from '@models/common/keyValueModel';

@Injectable({
  providedIn: 'root',
})
export class DetailsStoreService {
  private dmFieldService = inject(DmFieldsService);

  startTransition(
    documents: Record<number, DocumentDetails>,
    { id, roles, isComment, isEmail, isRevise }: EntityInstanceTransition,
    entityInstanceId: number,
    draftValues?: IdValueType<any, number>[],
  ): Observable<Record<number, DocumentDetails>> {
    const {
      params: { moduleId, contractId, workflowId },
    } = documents[entityInstanceId];

    const transitionId = isComment || isEmail || isRevise ? null : id;
    const actionId = transitionId ? null : id;
    const params = {
      transitionId,
      actionId,
      roleId: roles[0].key,
      entityInstanceId,
      moduleId,
      contractId,
      workflowId,
      draftValues,
    };
    return this.dmFieldService.getGridFields(params).pipe(
      map(gridFields =>
        produce(documents, draft => {
          const selectedDocument = draft[entityInstanceId];
          selectedDocument.transitionData = {
            ...selectedDocument.transitionData,
            gridFields,
            notificationData: {
              excludeRoles: gridFields.roleToExcludeIds,
              notify: gridFields.emails,
              notifyOptions: gridFields.emailsDataSource,
              hideRolesNotify: gridFields.hideRolesNotify,
            },
          };
          return draft;
        }),
      ),
    );
  }
}
